export const WINDOWS = 'windows';
export const MACOS = 'macos';
export const LINUX = 'linux';
export const CHROME = 'chrome';